import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import ModalWrapper from './ModalWrapper';
import './Modal.scss';

const Modal = props => {
    const { isPortal, containerId } = props;
    if (isPortal) {
        const container = document.getElementById(containerId);

        return ReactDOM.createPortal(<ModalWrapper {...props} />, container);
    }

    return <ModalWrapper {...props} />;
};

Modal.defaultProps = {
    isPortal: false,
    containerId: 'root',
};

Modal.propTypes = {
    isPortal: PropTypes.bool,
    containerId: PropTypes.string,
};

export default Modal;
